import type { Location } from 'react-router';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

export function isSamePageHref(href: string, location: Location, utilityContext: UtilityContext): boolean {
	if (href.startsWith('#')) return true;
	if (!href.includes('#')) return false;

	const homeUrl = utilityContext.resolveUrl('/');
	const parsedHomeUrl = new URL(homeUrl);

	// Use the actual home URL as the base for parsing relative URLs
	const parsedHref = new URL(href, homeUrl);

	// For same-origin URLs, check if pathname and search match current location
	if (parsedHref.origin === parsedHomeUrl.origin) {
		return location.pathname === parsedHref.pathname && location.search === parsedHref.search;
	}

	return false;
}
